// eslint-disable-next-line import/prefer-default-export
export const ADD_PROFILE = 'addNewProfile';
export const SELECT_PROFILE = 'selectProfile';
export const MANAGE_PROFILE = 'manageProfile';
